<template>
  <div>
  <footer v-if="isAuthenticated"
    class="main-footer">
    Developed by <a href="mailto:walidpiano@yahoo.com"><strong>Walid </strong>Zakaria</a>.
    <div class="float-right d-none d-sm-inline-block">Version 2.10.0</div>
  </footer>

</div>
  <!-- End Footer -->
</template>

<script>
export default {
  computed: {
    isAuthenticated() {
      return this.$store.getters['users/isAuthenticated'];
    },
  },
};
</script>

<style>
#footer {
  color: #fff;
  font-size: 14px;
  background: #111;
}
#footer .footer-top {
  padding: 60px 0 30px 0;
  background: #1e1e1e;
}
#footer .footer-top .footer-contact {
  margin-bottom: 30px;
}
#footer .footer-top .footer-contact h3 {
  font-size: 22px;
  margin: 0 0 10px 0;
  padding: 2px 0 2px 0;
  line-height: 1;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
}
#footer .footer-top .footer-contact p {
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 0;
  font-family: 'Roboto', sans-serif;
  color: rgba(255, 255, 255, 0.7);
}
#footer .footer-top h4 {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  position: relative;
  padding-bottom: 12px;
}
#footer .footer-top .footer-links {
  margin-bottom: 30px;
}
#footer .footer-top .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
#footer .footer-top .footer-links ul i {
  padding-right: 2px;
  color: #137cf5;
  font-size: 18px;
  line-height: 1;
}
#footer .footer-top .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
#footer .footer-top .footer-links ul li:first-child {
  padding-top: 0;
}
#footer .footer-top .footer-links ul a {
  color: rgba(255, 255, 255, 0.6);
  transition: 0.3s;
  display: inline-block;
  line-height: 1;
}
#footer .footer-top .footer-links ul a:hover {
  text-decoration: none;
  color: #fff;
}
#footer .footer-newsletter {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
}
#footer .footer-newsletter h4 {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  position: relative;
  padding-bottom: 12px;
}
#footer .footer-newsletter form {
  margin-top: 30px;
  background: #fff;
  padding: 6px 10px;
  position: relative;
  border-radius: 4px 0 0 4px;
  text-align: left;
}
#footer .footer-newsletter form input[type='email'] {
  border: 0;
  padding: 4px 8px;
  width: calc(100% - 100px);
}
#footer .footer-newsletter form input[type='submit'] {
  position: absolute;
  top: 0;
  right: -4px;
  bottom: 0;
  border: 0;
  background: none;
  font-size: 16px;
  padding: 0 20px;
  background: #137cf5;
  color: #fff;
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
}
#footer .footer-newsletter form input[type='submit']:hover {
  background: #137cf5;
}
#footer .credits {
  padding-top: 5px;
  font-size: 13px;
  color: #fff;
}
#footer .social-links a {
  font-size: 18px;
  display: inline-block;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  line-height: 1;
  padding: 8px 0;
  margin-right: 4px;
  border-radius: 4px;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}
#footer .social-links a:hover {
  background: #137cf5;
  color: #fff;
  text-decoration: none;
}

#made-by {
  display: block;
  margin: 0 auto;
  width: 100%;
  text-align: center;
  padding: 3px;
  background-color: #eeeeef;
}

.fa-caret-right {
  margin-right: 3px;
}
</style>
